<ngx-dropzone (change)="onFileChange($event)" [accept]="accept" multiple="false">
  <ngx-dropzone-label>Drag and drop a file here or click</ngx-dropzone-label>
  <ng-template [ngIf]="_file">
    <!-- SVG: use object URL so preview renders (ngx-dropzone-image-preview often shows broken icon for SVG) -->
    <ngx-dropzone-preview ngProjectAs="ngx-dropzone-preview" [file]="_file" *ngIf="accept === 'image/svg+xml' && _filePreviewSafeUrl && _file">
      <img [src]="_filePreviewSafeUrl" alt="SVG preview" style="max-width: 100%; max-height: 100px; width: 40px; height: 40px; object-fit: contain;">
    </ngx-dropzone-preview>
    <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" [file]="_file"
      *ngIf="accept.startsWith('image/') && accept !== 'image/svg+xml'">
    </ngx-dropzone-image-preview>
    <ngx-dropzone-video-preview ngProjectAs="ngx-dropzone-preview" [file]="_file" *ngIf="accept.startsWith('video/')">
    </ngx-dropzone-video-preview>
    <ngx-dropzone-preview ngProjectAs="ngx-dropzone-preview" [file]="_file"
      *ngIf="!accept.startsWith('image/') && !accept.startsWith('video/')">
      <ngx-dropzone-label>{{ _file.name }} ({{ _file.type }})</ngx-dropzone-label>
    </ngx-dropzone-preview>
  </ng-template>
</ngx-dropzone>